import { RestProvider, RestService } from '../rest/rest.service';
import { Models } from '@ibexfusion/models';
import { RestfulService } from '../rest/restful';
import { Injectable } from '@angular/core';

@Injectable()
export class ChatsService extends RestfulService<Models.Chat> {

  constructor(public restService: RestService) {
    super(Models.Chat);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('chats');
  }

}
